'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest(id, sendEpsCode) {
  this.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest__f_id = null;
  this.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest__f_sendEpsCode = null;
  this.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest__f_id = id;
  this.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest__f_sendEpsCode = sendEpsCode;
}
export { $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest as $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest };
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype.constructor = $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest;
/** @constructor */
function $h_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest() {
}
export { $h_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest as $h_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest };
$h_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype = $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype;
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1096410377), true);
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest)) {
    var x = this.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest__f_id;
    var x$2 = x$0.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest__f_id;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest__f_sendEpsCode;
      var x$4 = x$0.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest__f_sendEpsCode;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype.productPrefix__T = (function() {
  return "ForOneRequest";
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest__f_id;
  }
  if ((n === 1)) {
    return this.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest__f_sendEpsCode;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "sendEpsCode";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest)));
}
export { $isArrayOf_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest as $isArrayOf_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest };
var $d_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest, "app.pages.AppPage$DrugRequestsListOutstanding$ForOneRequest", ({
  Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest as $d_Lapp_pages_AppPage$DrugRequestsListOutstanding$ForOneRequest };
//# sourceMappingURL=app.pages.-App-Page$-Drug-Requests-List-Outstanding$-For-One-Request.js.map
